import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const TriangleExclamationMarkIcon = ({
  width = '24',
  height = '24',
  color: colorProp,
  ...restProps
}: IconProps) => {
  const { defaultColor } = useDefaultIconsColor();
  const color = colorProp || defaultColor;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M12 20.4197C12.6414 20.4197 13.1613 19.8998 13.1613 19.2584C13.1613 18.617 12.6414 18.097 12 18.097C11.3586 18.097 10.8386 18.617 10.8386 19.2584C10.8386 19.8998 11.3586 20.4197 12 20.4197Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.9999 8.80634C12.6387 8.80634 13.1468 9.32895 13.1177 9.96768L12.9 15.7816C12.8855 16.268 12.4862 16.6526 11.9999 16.6526C11.5136 16.6526 11.1144 16.268 11.0999 15.7816L10.8821 9.96768C10.8604 9.32895 11.3685 8.80634 11.9999 8.80634Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.8804 19.2584H19.7229C20.7028 19.2584 21.3198 18.1769 20.8262 17.3059L13.1033 4.23354C12.6097 3.36253 11.3903 3.36253 10.8967 4.23354L3.17382 17.3059C2.68025 18.1769 3.2972 19.2584 4.27709 19.2584H8.15806'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
